
import { Facilitator } from "./facilitator";
import { FoundationPrograms } from "../schoolPrograms/foundationProgram/foundationPrograms";

export const FacilitatorFoundationPrograms = () => {

    return (<>
        <Facilitator>
            <FoundationPrograms isAddFilesVisible={true} isDeleteFilesVisible={true}></FoundationPrograms>

        </Facilitator>
    </>);
}